// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__2bSh7","addWidgetButton":"Header_addWidgetButton__6vaLK","dashboardTabs":"Header_dashboardTabs__drT2L","active":"Header_active__etOiE"};